<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="120px" :rules="rules">
      <el-form-item label="当前责任人:">{{rowData.user_name}}</el-form-item>
      <el-form-item label="选择责任人:" prop="user_id">
        <el-select v-model="ruleForm.user_id">
          <el-option
            v-for="item in share.userList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
// import GlobalData from '@/api/global_data'

export default {
  name: '',
  data () {
    const taskId = this.rowData.task_id
    return {
      ruleForm: {
        task_id: taskId,
        user_id: ''
      },
      rules: {
        user_id: [{ required: true, message: '请选择责任人' }]
      },
      share: {
        userList: []
      }
    }
  },

  props: ['rowData'],

  created () {
    Backend.filterKeyValueList(this, 'user', '/warning_user/' + this.rowData.user_id, '', '', '', true)
  },

  methods: {
    confirm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          Backend.post(this, '/task/transfer_task', this.ruleForm).then(data => {
            this.$message.success('转发成功!')
            this.$emit('tableCloseDialog')
            this.rowData.user_id = data.user_id
            this.rowData.user_name = data.user_name
            // const pageData = GlobalData.tabShareData['任务列表'].pageData
            // if (pageData) {
            //   const src = pageData.items.find(it => it.task_id === this.rowData.task_id)
            //   Backend.copyObject(data, undefined, src)
            // }
          }).catch(e => {
            console.log(e)
          })
        }
      })
    }
  }
}
</script>
